'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExternalProgramsLink;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ExternalProgramsLink() {
  return _react2.default.createElement(
    'a',
    { href: 'https://etudier.uqam.ca/programmes', className: 'external', target: '_blank', rel: 'noopener noreferrer' },
    'Programmes d\u2019\xE9tudes et cours cr\xE9dit\xE9s',
    _react2.default.createElement(_caligramReact.Icon, { name: 'chevronRight' })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalProgramsLink.js
// module id = 1112
// module chunks = 0